export class ReorganizeLocations {
  deposit: string;
  installationUnit: string;
  documents: string[];

  constructor(deposit: string, installationUnit: string, documents: string[]) {
    this.deposit = deposit;
    this.installationUnit = installationUnit;
    this.documents = documents;
  }
}

export class Reorganize {
  origin: ReorganizeLocations;
  destination: ReorganizeLocations;

  constructor(origin: ReorganizeLocations, destination: ReorganizeLocations) {
    this.origin = origin;
    this.destination = destination;
  }
}